/* eslint-disable import/prefer-default-export */
import { ref } from "vue";
import { defineStore } from "pinia";
import useLocalStorage from "@/composables/storage/useLocalStorage.js";
import filters from "@/composables/store/filters";
import useFormValidation from "@/composables/validations/useFormValidation";

const { bindLocalStorage } = useLocalStorage();
const { validateNameField } = useFormValidation();
const { formHasErrors, getErrorByField } = filters();

const formObject = ref({
  givenName: {
    value: null,
    error: null,
    required: true,
    validator: validateNameField,
  },
  middleName: {
    value: null,
  },
  surname: {
    value: null,
    required: true,
  },
  addressLine1: {
    value: null,
    required: true,
  },
  suburb: {
    value: null,
    required: true,
  },
  state: {
    value: null,
    required: true,
  },
  postcode: {
    value: null,
    required: true,
  },
  country: {
    value: null,
    required: true,
  }
});

export const useUpdateDetailFormStore = defineStore({
  id: "updateDetailFormStore",
  state: () => ({
    form: formObject,
  }),
  getters: {
    formHasErrors: (store) => formHasErrors(store),
    getErrorByField: (store) => (field) => getErrorByField(store)(field),
  },
  actions: {
    updateValue(field, val) {
      if (Object.getOwnPropertyDescriptor(this.form[field], "validator")) {
        const { validator } = this.form[field];

        this.form[field].error = validator(field, val);
      }
      this.form[field].value = val;
      bindLocalStorage(this.$id, this.form);
    },
    updateRequiredFieldForKey(field, isRequired) {
      if (
        !field ||
        !Object.getOwnPropertyDescriptor(this.form, field) ||
        !Object.getOwnPropertyDescriptor(this.form[field], "required")
      ) {
        return;
      }

      this.form[field].required = isRequired;
    },
  },
});
